import React from 'react';
import { CheckCircle, Clock, AlertCircle } from 'lucide-react';

const statusConfig = {
  'completed': { icon: CheckCircle, className: 'text-green-600 bg-green-50' },
  'in-progress': { icon: Clock, className: 'text-blue-600 bg-blue-50' },
  'pending': { icon: AlertCircle, className: 'text-yellow-600 bg-yellow-50' }
};

function TaskStatusBadge({ status }) {
  const config = statusConfig[status] || statusConfig['pending'];
  const Icon = config.icon;

  return (
    <span className={`flex items-center px-2 py-1 rounded-full text-xs ${config.className}`}>
      <Icon className="w-3 h-3 mr-1" />
      {status.replace('-', ' ')}
    </span>
  );
}

export default TaskStatusBadge;